/*
 * Copyright (c) 2023.
 * Kevin <tranthaidnvn@gmail.com>
 */

import { config } from "core/config/app"

export const API_LOGIN = `${config.apiPrefix}/${config.apiVersion}/auth/sign-in`
export const API_LOGIN_SNS = `${config.apiPrefix}/${config.apiVersion}/auth/sns`
export const API_FETCH_ME_CLIENT = `${config.apiPrefix}/${config.apiVersion}/auth/me`
export const API_SIGNUP = `${config.apiPrefix}/${config.apiVersion}/auth/sign-up`
export const API_LOGOUT_CLIENT = `${config.apiPrefix}/${config.apiVersion}/auth/sign-out`
export const API_SEND_PASSWORD = `${config.apiPrefix}/${config.apiVersion}/auth/send-password`
export const API_VERIFY_TEMPORARY_PASSWORD = `${config.apiPrefix}/${config.apiVersion}/auth/verify-temporary-password`
export const API_RESET_PASSWORD = `${config.apiPrefix}/${config.apiVersion}/auth/reset-password`


export const API_CHECK_EMAIL = `${config.apiPrefix}/${config.apiVersion}/commons/check-email`

export const API_GET_CONTENT_POLICY = `${config.apiPrefix}/${config.apiVersion}/settings/term-of-policy`

export const API_CHECK_SNS = `${config.apiPrefix}/${config.apiVersion}/commons/check-sns`
